import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosButton, SovosTypography } from "mosaic-react";
import SoviOwlIcon from "mosaic-react-platform/sovos-platform-toolbar/components/shared/SoviOwlIcon";
import { useSoviAi } from "../../contexts/SoviAiContext";
import { openSoviWithMessage, getSoviPrompt } from "../../utils/soviChatUtils";
import styles from "./SoviDiagnoseBanner.module.sass";

export default function SoviDiagnoseBanner({ ruleId, fiscalYear, projectId, importIdFindings, ruleDetailedFinding }) {
    const { i18n } = useGlobalValue();
    const { hasAskSovi } = useSoviAi();

    if (!hasAskSovi) return null;

    const rawImportIdFindings = Array.isArray(importIdFindings)
        ? importIdFindings[0]?.ImportIDFindings
        : importIdFindings;
    const parsedImportIdFindings =
        typeof rawImportIdFindings === "string" && rawImportIdFindings
            ? rawImportIdFindings.split(" - ")[0].trim()
            : "full";

    const handleDiagnose = () => {
        const promptKey = ruleDetailedFinding ? "diagnoseRule" : "diagnoseRulePreview";
        const message = getSoviPrompt(promptKey, {
            ruleId,
            fiscalYear,
            projectId,
            importIdFindings: parsedImportIdFindings,
        });
        openSoviWithMessage(message);
    };

    return (
        <div className={styles["sovi-diagnose-banner"]}>
            <div className={styles["banner-inner"]}>
                <div className={styles["banner-content"]}>
                    <div className={styles["banner-icon"]}>
                        <SoviOwlIcon />
                    </div>
                    <SovosTypography variant="body1">
                        <strong>{i18n`Sovi Diagnose`}</strong>
                        {` - ${i18n`Your data has audit findings. Diagnose to understand them better and find out how to fix them.`}`}
                    </SovosTypography>
                </div>
                <SovosButton variant="outlined" onClick={handleDiagnose}>
                    {i18n`Diagnose`}
                </SovosButton>
            </div>
        </div>
    );
}
